export default {
  title: 'AI Agents',
  titleButton: 'New AI Agent',
  titleButtonShort: 'New',
  counter: `{count} {count, plural,
      one {AI Agent}
      other {AI Agents}
  }`,
  emptyState: {
    caption: `You haven't created any AI Agent yet`,
    button: 'Create your first AI Agent',
    noAiAgentsBeenShared: `No AI Agents have been shared with you yet`,
    howToGetStarted: {
      title: 'How to get started',
      examples: {
        title: 'AI Agents examples',
        description: 'Get inspired by our examples'
      },
      video: {
        title: 'Quickstart video',
        description: 'How to create your first agent'
      },
      documentation: {
        title: 'Documentation',
        description: 'Unlock the power of the platform'
      },
      academy: {
        title: 'CARTO Academy',
        description: 'Learning paths and tutorials'
      }
    }
  },
  sample: {
    overline: 'Need ideas?',
    title: 'Try our demo agents',
    demo: 'Demo'
  },
  dialog: {
    title: 'Select a map',
    ariaLabel: 'Select map for AI Agent'
  },
  filters: {
    search: 'Search AI Agents',
    noResults: 'No AI Agents were found'
  },
  cards: {
    tooltips: {
      disabled: 'Can only be edited in the Maps section'
    }
  }
}
